module.exports = __webpack_public_path__ + "img/hadware-min.f7c21987.png";